export const mutations = {
  COMMON_GSNACKBAR_COMMIT: "GSNACKBAR_COMMIT",
  COMMON_OPEN_GDIALOG: "COMMON_OPEN_GDIALOG",
  COMMON_CLOSE_GDIALOG: "COMMON_CLOSE_GDIALOG",
};

export const actions = {
  GSNACKBAR_COMMIT_COMMON: "gSnackbarCommit",
  GSNACKBAR_CLOSE: "gSnackbarClose",
  GLOADING_COMMIT_COMMON: "gLoadingCommit",
  TRACK_EVENT: "trackEvent"
};
